var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationSteering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.502 52.725L47.5 50.994A15.06 15.06 0 0055 38c0-8.271-6.729-15-15-15s-15 6.729-15 15a15.06 15.06 0 007.5 12.994l-1.002 1.731A17.065 17.065 0 0123 38c0-9.374 7.626-17 17-17 9.374 0 17 7.626 17 17 0 6.05-3.256 11.691-8.498 14.725",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M39 30h2v-8h-2zM39 14h2V8h-2zM25.866 64.48l-1.732-1 2.998-5.193 1.732 1-2.998 5.193M44.864 31.575l-1.732-1 4.004-6.933 1.732 1-4.004 6.933M52.868 17.713l-1.732-1 2.998-5.193 1.732 1-2.998 5.193M54.134 64.48l-3-5.195 1.732-1 3 5.195-1.732 1M35.134 31.572l-4-6.927 1.732-1 4 6.927-1.732 1M27.131 17.71l-2.997-5.19 1.732-1 2.997 5.19-1.732 1M64 39h6v-2h-6zM48 39h8v-2h-8zM24 39h8v-2h-8zM10 39h6v-2h-6zM65.48 53.866l-5.191-2.997 1-1.732 5.191 2.997-1 1.732M53.353 46.863l-5.859-3.383 1-1.732 5.859 3.383-1 1.732M32.573 34.866l-6.928-4 1-1.732 6.928 4-1 1.732M18.715 26.865l-5.195-2.999 1-1.732 5.195 2.999-1 1.732M61.287 26.864l-1-1.732 5.193-2.998 1 1.732-5.193 2.998M47.425 34.868l-1-1.732 6.932-4.002 1 1.732-6.932 4.002M26.643 46.866l-1-1.732 5.857-3.382 1 1.732-5.857 3.382M14.519 53.866l-1-1.732 5.194-2.998 1 1.732-5.194 2.998",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.333 61.576l-.666-1.885C56.838 56.449 63 47.732 63 38c0-12.683-10.318-23-23-23S17 25.317 17 38c0 9.732 6.161 18.449 15.332 21.691l-.667 1.885C21.697 58.053 15 48.578 15 38c0-13.785 11.215-25 25-25s25 11.215 25 25c0 10.578-6.698 20.053-16.667 23.576",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-2V38c0-3.859-3.14-7-7-7s-7 3.141-7 7v33h-2V38c0-4.963 4.038-9 9-9s9 4.037 9 9v33",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M10 72h60v-2H10z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 71h-2V40a1.001 1.001 0 00-2 0v31h-2V40c0-1.654 1.346-3 3-3s3 1.346 3 3v31",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationSteering;